import { SeekBarDuringAdBreak } from '@dicetechnology/dice-unity/lib/services/realm/types';
import {
    AdBreakProgress,
    ConnectedControlBar,
    ConnectedSeekBar,
    ConnectedTime,
    ControlBarSection,
    ControlBarSectionPosition,
    PauseIcon,
    usePlayerContext
} from '@dicetechnology/doris-ui';
import React, { useContext } from 'react';

import { ReceiverContext } from '../contexts';

import { Live } from './Live';

export const PlayerControls: React.FC = () => {
    const {
        state: { isPaused, isPlaying, hasPlayed, waiting, isPlayingBreak }
    } = usePlayerContext();

    const {
        settings: { seekBarDuringAdBreak }
    } = useContext(ReceiverContext);

    const adBreakProgress =
        seekBarDuringAdBreak === SeekBarDuringAdBreak.ADVERTISEMENT
            ? AdBreakProgress.SHOW_BREAK_CLIP
            : seekBarDuringAdBreak === SeekBarDuringAdBreak.AD_BREAK
            ? AdBreakProgress.SHOW_BREAK
            : AdBreakProgress.HIDDEN;

    const isAdSeekBarVisible = isPlayingBreak && adBreakProgress !== AdBreakProgress.HIDDEN;
    const isVisible = (hasPlayed && !isPlaying) || isAdSeekBarVisible;

    if (!isVisible) {
        return null;
    }

    return (
        <ConnectedControlBar className={'ds-control-bar--in'}>
            <ControlBarSection position={ControlBarSectionPosition.LEFT}>
                {!isPaused && !waiting && !isPlayingBreak && <Live />}
                {!waiting && isPaused && <PauseIcon />}
            </ControlBarSection>
            <ControlBarSection position={ControlBarSectionPosition.MAIN}>
                <ConnectedSeekBar adBreakProgress={adBreakProgress} sliderProps={{ draggable: false }} />
            </ControlBarSection>
            <ControlBarSection position={ControlBarSectionPosition.RIGHT}>{!isPlayingBreak && <ConnectedTime />}</ControlBarSection>
        </ConnectedControlBar>
    );
};
